//
//  src/components/enquire/EnquireOutcomeSent.js
//
import * as React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushContactSuccess } from "../google/Google";
import "./EnquireOutcome.css";

const IconSent = () => (
    <svg viewBox="0 0 60 60" width="80" height="80">
        <circle cx="30" cy="30" r="28" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <path
            d="M18 31 L27 40 L43 22"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function EnquireOutcomeSent({
    source = "form",
    title = "Thank You",
    subtitle = "Enquiry Received",
    message,
    secondary,
}) {
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.data && typeof location.state.files === "number") {
            pushContactSuccess(source, location.state.data, location.state.files).catch((error) => {
                console.error("pushContactSuccess:", error);
            });
        }
    }, [location.state, source]);

    return (
        <div className="contact-outcome-shell">
            <div className="contact-outcome contact-sent">
                <div className="contact-outcome-icon sent" aria-hidden="true">
                    <IconSent />
                </div>
                <h1>{title}</h1>
                <h4>{subtitle}</h4>
                {message}
                {secondary && <p className="contact-outcome-secondary">{secondary}</p>}
            </div>
        </div>
    );
}
